import pen from "./../sounds/pen.ogg";
import pencil from "./../sounds/pencil.ogg";
import ruler from "./../sounds/ruler.ogg";
import bag from "./../sounds/bag.ogg";
import book from "./../sounds/book.ogg";
import chair from "./../sounds/chair.ogg";
import crayon from "./../sounds/crayon.ogg";
import desk from "./../sounds/desk.ogg";
import notebook from "./../sounds/notebook.ogg";
import pencilcase from "./../sounds/pencilcase.ogg";
import picture from "./../sounds/picture.ogg";
import rubber from "./../sounds/rubber.ogg";

export const school = [{
        title: "pen",
        polish: "długopis",
        image:
          "https://images.unsplash.com/photo-1585336261022-680e295ce3fe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        sounds: pen,
      },
      {
        title: "bag",
        polish: "plecak",
        image:
          "https://images.unsplash.com/photo-1581605405669-fcdf81165afa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
        sounds: bag,
      },
      {
        title: "book",
        polish: "książka",
        image:
          "https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
        sounds: book,
      },
      {
        title: "chair",
        polish: "krzesło",
        image:
          "https://images.unsplash.com/photo-1546821427-a542fbacda8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        sounds: chair,
      },
      {
        title: "crayon",
        polish: "kredka",
        image:
          "https://images.unsplash.com/photo-1520881685182-f4f6a103adf5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1047&q=80",
        sounds: crayon,
      },
      {
        title: "desk",
        polish: "biurko",
        image:
          "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=675&q=80",
        sounds: desk,
      },
      {
        title: "notebook",
        polish: "zeszyt",
        image:
          "https://images.unsplash.com/photo-1581431886211-6b932f8367f2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        sounds: notebook,
      },
      {
        title: "pencil case",
        polish: "piórnik",
        image:
          "https://images.unsplash.com/photo-1574944558125-f8d12f23be89?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
        sounds: pencilcase,
      },
      {
        title: "picture",
        polish: "obrazek",
        image:
          "https://images.unsplash.com/photo-1452457005517-a0dd81caca2a?ixlib=rb-1.2.1&auto=format&fit=crop&w=986&q=80",
        sounds: picture,
      },
      {
        title: "rubber",
        polish: "gumka",
        image:
          "https://images.unsplash.com/photo-1583912536788-eb9fa64db55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        sounds: rubber,
      },
      {
        title: "pencil",
        polish: "ołówek",
        image:
          "https://images.unsplash.com/photo-1598714479411-a11ad65f7b2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=675&q=80",
          sounds: pencil,
      },
      {
        title: "ruler",
        polish: "linijka",
        image:
          "https://images.unsplash.com/photo-1529651795107-e5a141e34843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
          sounds: ruler,
      }];
